import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CUSTOM_VENDOR_REPORTING_DETAILS,
  CUSTOM_VENDOR_REPORTING_DETAILS_DELETE,
  CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE,
  CUSTOM_VENDOR_REPORTING_FILTERS,
  CUSTOM_VENDOR_REPORTING_OVERVIEW,
  CustomVendorReportingState,
  customVendorReportingFeatureKey,
  CUSTOM_RIO_DATA_EVALUATION_OVERVIEW,
  CUSTOM_DATA_EVALUATION_FILTERS
} from './custom-vendor-reporting.reducer';

export const selectCustomVendorReportingState =
  createFeatureSelector<CustomVendorReportingState>(
    customVendorReportingFeatureKey
  );

//******************************************************

export const selectVendorReportingOverview = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_OVERVIEW].vendorReportingOverview
);

export const loadingVendorReportingOverview = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_OVERVIEW].isLoading
);

export const errorVendorReportingOverview = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_OVERVIEW].error
);

export const selectVendorReportingFilters = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_FILTERS].searchFilters
);

//******************************************************

export const selectVendorReportingDetails = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS].vendorReportingDetails
);

export const loadingVendorReportingDetails = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS].isLoading
);

export const errorVendorReportingDetails = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS].error
);

//******************************************************

export const updateVendorReportingDetailsSuccess = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE].success
);

export const updateVendorReportingDetailsFailure = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE].error
);

export const updateVendorReportingDetailsFailureMessage = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE].messages
);
//******************************************************

export const deleteVendorReportingDetailsSuccess = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS_DELETE].success
);

export const deleteVendorReportingDetailsFailure = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_VENDOR_REPORTING_DETAILS_DELETE].error
);

//******************************************************

export const selectRioDataEvaluationOverview = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_RIO_DATA_EVALUATION_OVERVIEW].vendorReportingOverview
);

export const loadingRioDataEvaluationOverview = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_RIO_DATA_EVALUATION_OVERVIEW].isLoading
);

export const errorRioDataEvaluationOverview = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_RIO_DATA_EVALUATION_OVERVIEW].error
);

export const selectRioDataEvaluationFilters = createSelector(
  selectCustomVendorReportingState,
  (state: CustomVendorReportingState) =>
    state[CUSTOM_DATA_EVALUATION_FILTERS].searchFilters
);